import { render, staticRenderFns } from "./LockerEdit.vue?vue&type=template&id=2926514b&"
import script from "./LockerEdit.vue?vue&type=script&lang=js&"
export * from "./LockerEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports